export const LICENSE_STATUS_OPTIONS = [
  { value: '', label: 'Todos os status' },
  { value: '1', label: 'Aguardando abertura' },
  { value: '2', label: 'Processo aberto' },
  { value: '3', label: 'Licença emitida' },
  { value: '4', label: 'Solicitada prorrogação' },
  { value: '5', label: 'Finalizado' },
  { value: '6', label: 'Suspensa' },
  { value: '7', label: 'Cassada' },
];

function rowDate(value) {
  if (!value) return null;
  const d = new Date(value);
  return Number.isNaN(d.getTime()) ? null : d;
}

export function filterLicenseRows(
  rows,
  { query = '', status = '', type = '', enterprise = '', dateTo = '', requerenteId = '', empreendimentoId = '' } = {}
) {
  let next = rows;
  const q = String(query || '').trim().toLowerCase();
  if (q) {
    next = next.filter(
      (r) =>
        String(r.id).toLowerCase().includes(q) ||
        String(r.numero || '').toLowerCase().includes(q) ||
        String(r.enterprise || '').toLowerCase().includes(q) ||
        String(r.type || '').toLowerCase().includes(q) ||
        String(r.responsible || '').toLowerCase().includes(q) ||
        String(r.status || '').includes(q)
    );
  }
  if (status) {
    next = next.filter((r) => String(r.status) === String(status));
  }
  if (type) {
    const tipo = String(type).toLowerCase();
    next = next.filter(
      (r) =>
        String(r.raw?.tipo_licenca_id || '').toLowerCase() === tipo ||
        String(r.type || '').toLowerCase() === tipo
    );
  }
  if (enterprise) {
    const term = String(enterprise).trim().toLowerCase();
    next = next.filter((r) => String(r.enterprise || '').toLowerCase().includes(term));
  }
  if (requerenteId) {
    const clientId = String(requerenteId).trim();
    next = next.filter((r) => String(r.raw?.requerente_id || '') === clientId);
  }
  if (empreendimentoId) {
    const empId = String(empreendimentoId).trim();
    next = next.filter((r) => String(r.raw?.empreendimento_id || '') === empId);
  }
  if (dateTo) {
    const limit = rowDate(dateTo);
    if (limit) {
      next = next.filter((r) => {
        const exp = rowDate(r.expirationDate);
        return exp && exp <= limit;
      });
    }
  }
  return next;
}
